export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

//clinics
export const GET_CLINIC_LIST = "GET_CLINIC_LIST";
export const ADD_CLINIC_LIST = "ADD_CLINIC_LIST"